<template>
  <v-dialog
    v-model="show"
    max-width="600px"
  >
    <v-card>
      <v-card-title>
        Request For Raise
        <v-spacer></v-spacer>
        <v-btn
          icon
          blur
          @click.prevent="show = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="py-2">
        <v-row>
          <v-col cols="12" md="6" lg="6">
          <h3>Position: {{ this.employee.Status }}</h3>
          </v-col>
        <v-col cols="12" md="6" lg="6">
          <h3>Salary: {{ this.employeeSalary }}</h3>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6" lg="6">
            <v-select
              v-model="requestForRaise.Status"
              label="New Position"
              :items="emplStatuses"
              item-text="Status_Descr"
              item-value="Status_ID"
            ></v-select>
        </v-col>
          <v-col cols="12" md="6" lg="6">
            <v-text-field
              v-model="requestForRaise.Salary"
              label="New Salary"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pt-0" cols="12" md="12" lg="12">
            <v-textarea
              v-model="requestForRaise.Reason"
              rows="2"
              label="Reason"
            ></v-textarea>
        </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small color="primary" @click="sendRequestForRaise">Send</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'RaiseRequest',
  props: {
    value: {
      required: true,
      default: false
    },
    employee: {
      required: false,
      default: null
    }
  },
  data () {
    return {
      isStagingEnv: process.env.NODE_ENV === 'staging',
      isDevEnv: process.env.NODE_ENV === 'development',
      requestForRaise: {
        Request_ID: 0,
        Status: this.employee.Status_ID,
        Salary: 0,
        Employee_ID: 0,
        Reason: ''
      },
      notificationData: {
        Notification_Type_ID: 1,
        Notification_Title: '',
        Notification_Message: '',
        Notification_Created: new Date().toISOString().substr(0, 10),
        Notification_Employee_ID_From: undefined,
        Notification_Employee_ID_To: undefined
      },
      CEO_ID: 2
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
        if (!this.value) {
          this.clearAll()
        }
      }
    },
    user () {
      return this.$store.getters.getUser
    },
    employeeSalary () {
      if (!this.employee?.Employee_Rate?.length) {
        return 0
      }

      const rate = this.employee.Employee_Rate[this.employee.Employee_Rate.length - 1]
      return rate.Salary_Type === 'RATE' ? rate.Rate : rate.Salary
    },
    emplStatuses () {
      return this.$store.getters.getStatuses
    },
    employeeAM () {
      let empl = this.$store.getters.getAllEmployee
      empl = empl.filter(item => item.Status === 'Account Manager (AM)' && item.Department === this.employee.Department)[0].Employee_ID
      return empl
    }
  },
  mounted () {
    if (this.isStagingEnv || this.isDevEnv) {
      this.CEO_ID = 938
    }
  },
  methods: {
    sendRequestForRaise () {
      const status = this.emplStatuses.filter(item => item.Status_ID === this.requestForRaise.Status)[0].Status_Descr
      const confirmer = status !== 'Junior Coder' ? this.CEO_ID : this.employeeAM
      this.axios.post('api/requests/raise', {
        Approved: false,
        Date_of_Create: new Date().toISOString().substr(0, 10),
        Date_of_Update: new Date().toISOString().substr(0, 10),
        Creator_ID: this.user.employee_id,
        Confirmer_ID: confirmer,
        Employee_ID: this.employee.Employee_ID,
        Status_ID: this.requestForRaise.Status,
        Salary: this.requestForRaise.Salary,
        Reason: this.requestForRaise.Reason
      }, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(response => {
        this.sendNotificationAboutRaise(response.data[0].Request_ID, confirmer, status, this.requestForRaise.Reason)
        this.$store.dispatch('setSuccess', { successMsg: 'Request for raise was made' })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    sendNotificationAboutRaise (requestId, confirmerId, status, reason) {
      this.notificationData.Notification_Message = `
        Requester:  ${this.user.full_name},
        For employee: ${this.employee.Full_Name},
        Old Postion: ${this.employee.Status} -> New Position: ${status}
        Old Salary: ${this.employeeSalary} -> New Salary: ${this.requestForRaise.Salary}
        Reason: ${reason}
        `
      this.notificationData.Notification_Title = 'Request for raise'
      this.notificationData.Notification_Created = new Date()
      this.notificationData.Notification_Employee_ID_From = this.user.employee_id
      this.notificationData.Notification_Employee_ID_To = confirmerId
      this.notificationData.Request_ID = requestId
      this.axios.post('/api/requests/raise_notification', this.notificationData,
        {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }
      ).then(res => {
        this.sendEmailForRaiseRequest(confirmerId, this.notificationData)
        this.show = false
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    clearAll () {
      this.requestForRaise = {
        Request_ID: 0,
        Status: 0,
        Salary: 0,
        Employee_ID: 0,
        Reason: ''
      }
    },
    sendEmailForRaiseRequest (confirmerId, notifdata) {
      const employeeIDs = confirmerId
      const body = {
        employeeIDs: employeeIDs,
        notificationData: notifdata
      }
      this.axios.post('/api/emails/sendemailforraiserequest', body, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.$store.dispatch('setSuccess', { successMsg: 'Email sent' })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message })
      })
    }
  }
}
</script>
